import { get, find, includes } from 'lodash';

// Mapeo del error del back (save_csv) a texto para el usuario.
// OJO: save_csv devuelve errores de CSV con status 500 (no solo 4xx), así que se mapea por el
// MENSAJE, no por el status: si el mensaje matchea un error conocido de CSV → texto accionable;
// si no → genérico (fallo interno).
export const csvErrorHints = [
    { match: 'columns', text: 'El CSV debe tener exactamente las columnas: EAN, SKU y AISLE.' },
    { match: 'Only CSV', text: 'El archivo debe ser un CSV.' },
    { match: 'empty', text: 'El archivo CSV está vacío.' },
    { match: 'must be an integer', text: 'La sala no es válida.' },
    { match: 'required', text: 'Faltan datos obligatorios para la carga.' }
];

export const importBodyResolver = (status, message) => {
    if (status === '200' || status === '201') {
        return { icon: 'check-mark', firstLine: 'Archivo importado correctamente', secondLine: 'Las ubicaciones se procesarán en unos minutos' };
    }
    const hint = get(find(csvErrorHints, ({ match }) => includes(message || '', match)), 'text');
    if (hint) {
        return { icon: 'notConnection', firstLine: 'Revisa el archivo CSV', secondLine: hint };
    }
    return { icon: 'notConnection', firstLine: 'No se pudo procesar la carga', secondLine: 'Ocurrió un error al importar. Intenta nuevamente o contacta a soporte.' };
};
